import { ReactNode } from 'react';
import styles from './Modal.module.scss';

interface ModalDialogProps {
  children: ReactNode;
  classNames?: string;
}

const ModalDialog = ({ children, classNames }: ModalDialogProps) => {
  return (
    <div className={styles.modal__dialog}>
      <div className={`${styles.modal__content} ${classNames}`}>{children}</div>
    </div>
  );
};

export default ModalDialog;
